<template>
  <div id="app">
    <!-- <top-header></top-header>
    <router-view></router-view>-->
    <Assignment></Assignment>
  </div>
</template>

<script>
import Header from "./components/Top-Header";
import Assignment from "./components/Assignment";

export default {
  components: {
    "top-header": Header,
    Assignment
  }
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  width: 100vw;
}
</style>
